module.exports = fox._r("fonts/woodfordbourne-regular-webfont.ttf", __webpack_public_path__ + "fonts/2ndGGSc.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/woodfordbourne-regular-webfont.ttf
// module id = 10
// module chunks = 5